import { observer } from 'mobx-react';
import * as React from 'react';
import ParticipantStore from '../../../../ParticipantStore';
import ParticipantsStore from '../../../../ParticipantsStore';
import AddLicenseToParticipants from './AllocateLicenseToParticipants';
import AddToUserGroup from './AddParticipantsToGroup/OpenModalButton';
import Count from './Count';
import ReclaimLicenses from './ReclaimLicenses';

interface Props {
  store: ParticipantsStore;
  checkedParticipants: ParticipantStore[];
}

const BulkActions: React.FC<Props> = ({ store, checkedParticipants }) => (
  <div className="flex justify-center fixed bottom-10 inset-x-0 w-[55%] m-auto">
    <div className="flex gap-5 justify-center items-center py-3 px-20 rounded-md bg-white drop-shadow">
      <Count participantCount={checkedParticipants.length} />
      <AddToUserGroup store={store} />
      <AddLicenseToParticipants
        participantsStore={store}
        checkedParticipants={checkedParticipants}
      />
      <ReclaimLicenses store={store} />
    </div>
  </div>
);

export default observer(BulkActions);
